import Joi from 'joi';

import { generateJoiValidation } from '@/shared/validations/generateJoiValidation';
import { ProjectCharge } from '@/modules/projectCharge/projectCharge.model';
import { objectId } from '@/shared/validations/custom.validation';

export const createProjectCharge = () => ({
  body: generateJoiValidation(ProjectCharge.schema),
});

export const updateProjectCharge = () => ({
  query: Joi.object().keys({
    id: Joi.string().custom(objectId).required(),
  }),
  body: generateJoiValidation(ProjectCharge.schema, true),
});

export const getProjectCharge = {
  query: Joi.object().keys({
    name: Joi.string(),
    projectCharge: Joi.string(),
    sortBy: Joi.string(),
    search: Joi.string(),
    limit: Joi.number().integer().min(1),
    page: Joi.number().integer().min(-1),
    companyId: Joi.string(),
    includeTimeStamps: Joi.boolean(),
  }),
};

export const getProjectChargeById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};

export const deleteProjectChargeById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};
